module.exports = __webpack_public_path__ + "static/media/pinfo.35cd33fa.svg";